import React from "react";
import ReactDOM from "react-dom";

import MeshLineComponent from "./MeshLineComponent";

const rootElement = document.getElementById("root");
ReactDOM.render(
  <React.StrictMode>
    <MeshLineComponent />
  </React.StrictMode>,
  rootElement
);
